import {
    getConnection,
    getCurSession,
    getStatusID,
    setIsBPMChanged
} from '../../../../../_shared/GWTBridge/invoke/bpm/bpmMain';
import {BpmAlertResponse, GWTMetaData} from './types';
import {buildServerCall} from '../../../../../services/wcfService';
import {handleBPMMessages} from '../utils/handlePermission';
import {bpmRulesStorage} from '../BPM.rules.storage';

export const bpmDeleteRule = async (
    alertNumber: string,
    fromStatus: string = '',
    toStatus: string = ''
) => {
    const methodName = 'BPMAlertDel';
    const reason = 'BPMAlertDel';

    const fromid = getStatusID(fromStatus)?.toString();
    const toid = getStatusID(toStatus)?.toString();

    const storageData = bpmRulesStorage.getStorage(getCurSession());

    const parameters = {
        session: [getCurSession()],
        alert: [alertNumber],
        fromid: [fromid],
        toid: [toid]
    };

    const res: BpmAlertResponse = await buildServerCall(
        methodName,
        parameters,
        reason,
        true,
        getConnection
    );

    const BPM = res?.BPM?.[0];
    const isOk = await handleBPMMessages(BPM as GWTMetaData);

    if (isOk) {
        // Triggers GWT state change flag
        setIsBPMChanged(true);

        storageData?.removeSingleRule(fromid, toid, alertNumber);
    }

    return isOk;
};
